export const LAST_MONTH_SLICE = 12;
export const MONTH_IN_A_YEAR = 12;
export const SKIP_FIRST_3_MONTHS = 3;
export const SKIP_LAST_3_MONTHS = -3;
export const STARTING_MONTH = 0;
